import type { SelectedLot } from "./hooks/useInventoryAdjustmentPalletGroupSelection"
import { InventoryAdjustmentWarehouseLabel } from "./InventoryAdjustmentWarehouseLabel"

import type { InventoryByProductWarehouse } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const buildInventoryAdjustmentWarehouseOptions = (
  warehouseInventories: InventoryByProductWarehouse[]
): Option<string>[] =>
  warehouseInventories.map((inventory) => ({
    value: inventory.warehouseArea!.warehouseAreaId,
    label: <InventoryAdjustmentWarehouseLabel warehouseInventory={inventory} />,
  }))

export const getInventoryAdjustmentUntestedLots = (selectedLots: SelectedLot[]): SelectedLot[] =>
  selectedLots.filter(({ lot }) => !lot.hasProductTest)
